module.exports = __webpack_public_path__ + "static/media/share.7a4b662e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/share.svg
// module id = 1349
// module chunks = 0